import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {provideParent, StateMap, UnitOfWork, UserManager} from '../../services/common';
import { EditPropParent } from '../../controls/common';
import { TabContainer } from '../../controls/common';
import { LocationFns, UtilFns } from '../../utils/common';

import { NCSUploadComponent } from './ncs-upload.component';
import {STAFF_ROUTES} from './staff.routes';
import {NCSEditData, NCSViewerComponent} from './ncs-viewer.component';

import {Material} from '../../entities/EntityModels';
import {MaterialComponentCandidate} from '../../entities/projections/MaterialComponentCandidate';

export class NCSManagerData {
    currentTab: number;
    materialId: number;
    materialComponentCandidates: MaterialComponentCandidate[] = [];
    canSaveMaterialComponentCandidates: boolean;
}

@Component({
    selector: 'ncs-manager',
    templateUrl: './ncs-manager.html',
    providers: [provideParent(NCSManagerComponent, EditPropParent)]
})
export class NCSManagerComponent implements OnInit {
    @ViewChild(NCSUploadComponent) _ncsUploadComponent: NCSUploadComponent;
    @ViewChild(NCSViewerComponent) _ncsViewer: NCSViewerComponent;
    @ViewChild(TabContainer) _tabContainer: TabContainer;

    public _data: NCSManagerData = new NCSManagerData();

    // _tab: number;

    public _isLoading: boolean;

    constructor(private _uow: UnitOfWork, private _stateMap: StateMap, private _userManager: UserManager, private _router: Router,
                public _route: ActivatedRoute, public _location: Location) {

    }

    ngOnInit() {
        this._stateMap.currentRouteName = STAFF_ROUTES.NCSManager.name;

        this._data.currentTab = 0;
        this.setTab(0);
    }

    canDeactivate() {
        return (!this._uow.hasChanges());
    }

    // ******************************************************
    // *Tab Events                                          *
    // ******************************************************
    ncsEventHandler(event: string) {

        switch (event) {
            case 'view': {
                this.setTab(1);
                break;
            }
            default: {
                break;
            }
        }
    }

    setTab(tabNumber: number) {
        this._data.currentTab = tabNumber;
        setTimeout(() => {this._tabContainer.selectTab(tabNumber);
        }, 1);
    }

}
